var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.alerts),function(alert){return _c('v-alert',{key:alert.id,attrs:{"type":alert.status}},[_c('span',{domProps:{"innerHTML":_vm._s(alert.alert_text)}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }